'use strict';

angular.module('openDataApp')
  .controller('EmergencyFormCtrl', ['$scope', '$q', '$location', '$timeout', 'moment', 'ApiService', function ($scope, $q, $location, $timeout, Moment, ApiService) {

    $scope.formData = { };
    $scope.greatSuccess = false;

    $scope.changePlan = function(plan) {
      $scope.formData.plan = plan;
      return false;
    };

    $scope.submit = function(formData) {
      if (!$scope.greatSucces) {
        $scope.submitting = true;
        $scope.emergencyFormSubmitError = null;

        var def = $q.defer(),
            order = {};

        order[formData.plan] = 1;
        ApiService.checkout(order)
          .then(
            function success(response) {
              $scope.greatSuccess = true;
              $timeout(function () {
                window.location.href = response.data.response;
              }, 2000);
              def.resolve();
            },
            function error(response) {
              $scope.submitting = false;
              $scope.emergencyFormSubmitError = response.data.error !== undefined ? response.data.error : 'Er is iets misgegaan, probeer het later nog eens.';
              def.reject();
            }
          );

        return def.promise;
      }
    };
  }]);
